
/** 
* This file has been auto-generated by '@kontent-ai/model-generator@8.1.1'.
* 
* (c) Kontent.ai
*  
* -------------------------------------------------------------------------------
* 
* Project: UnumUK Employer Portal
* Environment: Dev (Previously Phase 2)
* Id: a5beabf7-cb3f-0126-9900-a0a631d69346
* 
* -------------------------------------------------------------------------------
**/

import type { Elements } from '@kontent-ai/delivery-sdk';
import type { CoreContentType } from "../system/index.js";

/**
 * 📷 Media // Asset
 *
 * Id: 6980d738-95e6-4174-933d-ebe6ebabb3bf
 * Codename: asset
 */
export type MediaAsset = CoreContentType<
    MediaAssetElementCodenames,
    {
        /**
         * Image
         *
         * Type: asset
         * Required: true
         * Codename: image
         * Id: 6e0906e6-fd51-48e7-8c78-0f9967332391
         */
        readonly image: Elements.AssetsElement;
        /**
         * Caption
         *
         * Type: text
         * Required: false
         * Codename: caption
         * Id: 27e2396e-391d-450f-97b7-5dee61193d09
         */
        readonly caption: Elements.TextElement;
    },
    'asset'
>;

/**
 * Type representing all available element codenames for 📷 Media // Asset
 */
export type MediaAssetElementCodenames = 'image' | 'caption';

/**
 * Type guard for 📷 Media // Asset
 *
 * Id: 6980d738-95e6-4174-933d-ebe6ebabb3bf
 * Codename: asset
 */
export function isMediaAsset(item: CoreContentType | undefined | null): item is MediaAsset {
    return item?.system?.type === 'asset';
}
